import { defineMessages } from 'react-intl';

/**
 * Copy for the MCP site picker.
 *
 * Some ids read oddly against their copy: `.label.sites` and
 * `.placeholder.plural` were suffixed back when this screen ran alongside a
 * second MCP implementation, and `.noWorkspaces.learnMore` names a state the
 * sentence no longer mentions. Each keeps the id it was first extracted under
 * so existing extractions and translations keep resolving — renaming one drops
 * its copy silently.
 */
export const mcpSiteSelectorMessages = defineMessages({
  siteLabel: {
    id: 'oauth.mcp.siteSelector.label.sites',
    defaultMessage: 'Site (For Jira, Confluence and other tools)',
    description: 'Label above the site-picker dropdown',
  },
  sitePlaceholder: {
    id: 'oauth.mcp.siteSelector.placeholder.plural',
    defaultMessage: 'Select',
    description: 'Placeholder text inside the multi-select site picker',
  },
  noSites: {
    id: 'oauth.mcp.siteSelector.noSites',
    defaultMessage:
      "Your account isn't associated with a supported site. Rovo MCP connects with Atlassian sites that use apps like Jira or Confluence. {learnMoreLink}",
    description:
      'Message below the disabled site picker when the user has no supported sites; {learnMoreLink} links to Rovo MCP documentation',
  },
  noPermissions: {
    id: 'oauth.mcp.siteSelector.noPermissions',
    defaultMessage:
      'Permissions are blocked for this site, contact your admin or {learnMoreLink}',
    description:
      'Message below the site picker when the permission check succeeded but returned no permissions; {learnMoreLink} links to the admin guide for managing MCP permissions',
  },
  noPermissionsLearnMore: {
    id: 'oauth.mcp.siteSelector.noPermissions.learnMore',
    defaultMessage: 'see how permissions are managed',
    description:
      'Link text, inside a sentence, pointing at the admin guide for managing MCP permissions',
  },
  orgConstraint: {
    id: 'oauth.mcp.siteSelector.orgConstraint',
    defaultMessage:
      'Only sites from the same organization as the workspace can be selected',
    description:
      'Helper below the site picker when a Bitbucket workspace is already selected, so other-org sites are listed but disabled',
  },
  noOrgSites: {
    id: 'oauth.mcp.siteSelector.noOrgSites',
    defaultMessage:
      'No sites from the same organization as the selected workspace are available',
    description:
      'Helper below the site picker when a Bitbucket workspace is selected and every listed site is in a different organization',
  },
  noWorkspacesLearnMore: {
    id: 'oauth.mcp.siteSelector.noWorkspaces.learnMore',
    defaultMessage: 'Understand Rovo MCP Server',
    description:
      'Link text for the Rovo MCP documentation shown when no workspaces are available',
  },
});
